<template>
  <div class="liquor-game">
    <Header active="/liquor/dana" />

    <HeaderSelect active="dana" :list="headerSelectArray" />

    <div class="container">
      <component
        :is="scene"
        @changeScene="handleScene"
        @changeForegroundMusic="changeForegroundMusic"
        @changeBackgroundMusic="changeBackgroundMusic"
      ></component>

      <div class="audio">
        <AudioController ref="ac" />
      </div>
    </div>

    <Sticky ref="sticky" />
  </div>
</template>

<script>
import Header from "@/components/liquor/Header";
import HeaderSelect from "@/components/liquor/HeaderSelect";
import Sticky from "@/components/liquor/Sticky";

import AudioController from "@/components/game/common/AudioController";

import LoadingScene from "@/components/game/scene/LoadingScene";

import MainScene from "@/components/game/scene/MainScene";
import PlotScene from "@/components/game/scene/PlotScene";

import GuideScene from "@/components/game/scene/GuideScene";

import CheckpointPlotScene from "@/components/game/scene/CheckpointPlotScene";
import CheckpointStartScene from "@/components/game/scene/CheckpointStartScene";
import CheckpointAnswerScene from "@/components/game/scene/CheckpointAnswerScene";
import CheckpointResultScene from "@/components/game/scene/CheckpointResultScene";
import CheckpointTaskScene from "@/components/game/scene/CheckpointTaskScene";

import GameOverScene from "@/components/game/scene/GameOverScene";
import MyRewardsScene from "@/components/game/scene/MyRewardsScene";
import MyRankingScene from "@/components/game/scene/MyRankingScene";

export default {
  name: "LiquorGame",
  components: {
    Header,
    HeaderSelect,
    Sticky,

    AudioController,

    LoadingScene,
    MainScene,
    GuideScene,
    PlotScene,
    CheckpointPlotScene,
    CheckpointStartScene,
    CheckpointAnswerScene,
    CheckpointResultScene,
    CheckpointTaskScene,
    GameOverScene,
    MyRewardsScene,
    MyRankingScene
  },
  data() {
    return {
      scene: "LoadingScene",
      foregroundSrc: "",
      backgroundSrc: "",
      headerSelectArray: [
        {
          name: "专业词汇",
          link: "/liquor/dana",
          active: false
        },
        {
          name: "知识挑战",
          link: "/liquor/game",
          active: true
        }
      ]
    };
  },
  methods: {
    handleScene(e) {
      this.scene = e;
    },
    changeForegroundMusic(src, bool) {
      this.$refs["ac"].playFore(src, bool);
    },
    changeBackgroundMusic(src, bool) {
      this.$refs["ac"].playBack(src, bool);
    }
  }
};
</script>

<style lang="scss" scoped>
.liquor-game {
  width: 100%;
  margin: 180px 0;
  position: relative;

  .container {
    width: 1100px;
    height: 560px;
    margin: 0 auto;
    position: relative;
    background: black;
    overflow: hidden;

    .audio {
      position: absolute;
      top: 100px;
      right: 20px;
      cursor: pointer;
    }
  }
}
</style>